import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const UserDataEncryptionSettings = lazy(() =>
  import("@scenes/UserDataEncryptionSettings").then((module) => ({
    default: module.UserDataEncryptionSettings,
  }))
);

export const userDataEncryptionNRO: NavigationRoutingObject = {
  Component: UserDataEncryptionSettings,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "data-settings",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("user-data-encryption-nro-heading", "Identifier Field-Level Encryption"),
  description: (t: I18nT<"dashboard-navigation">) =>
    t("user-data-encryption-nro-description", "Engage with users without storing their PII in our databases"),
  icon: "nav-system-user-data-encryption",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("pii_fields_encryption");
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    { keywords: [t("user-data-encryption-nro-alt-keyword-1", "pii")] },
  ],
  additionalSearchableFeatures: () => ({}),
};
